import React, { Component } from "react";
import "../styles/Tab.css";

class Tab extends Component {
  state = {
    pressed: false,
    hovered: false
  };

  mouseDown() {
    this.setState({ pressed: true });
  }

  mouseUp() {
    this.setState({ pressed: false });
  }

  mouseEnter() {
    this.setState({ hovered: true });
  }

  mouseLeave() {
    this.setState({ hovered: false });
  }

  render() {
    const classes = ["tab"];

    if (this.state.hovered) {
      classes.push(`tab--hovered`);
    } else if (this.props.selected || this.state.pressed) {
      classes.push(`tab--selected`);
    }

    return (
      <div
        className={classes.join(" ")}
        onMouseDown={this.mouseDown.bind(this)}
        onMouseUp={this.mouseUp.bind(this)}
        onMouseEnter={this.mouseEnter.bind(this)}
        onMouseLeave={this.mouseLeave.bind(this)}
        onClick={() => this.props.onClicked()}
      >
        {this.props.children}
      </div>
    );
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./src/elements/Tab.js